import {
  getAllContracts,
  getContractById,
  removeEstablishments,
  setEstablishments,
  setContractEnd
} from '../api/contract';


export async function getContract(cont_id){
  const contract = await getContractById(cont_id);

  return contract;
}

export async function getContracts() {
  const allContrats = await getAllContracts();
  return allContrats;
}

export async function removeEstablishment(cont_id, esta_id){
  const params = { cont_id, establishments: []};
  params.establishments.push(esta_id);
  const result = await removeEstablishments(params);
  return result;
}

export async function addEstablishment(cont_id, esta_id){
 const params = { cont_id, establishments: []};
  params.establishments.push(esta_id);
  const result = await setEstablishments(params);
  return result;
  
}

export async function setDateEndContract( cont_id, date_end) {
  if (date_end === "") date_end = null;
  const result = await setContractEnd(cont_id, date_end);
  return result;
}